import { KeyboardArrowUpIcon, KeyboardArrowDownIcon } from 'tuui';
import { Collapsible } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './collapsibleView.module.scss';

export const CollapsibleView = ({
    collapsed,
    setCollapsed,
    showArrow = true,
    expandMessage = <FormattedMessage id="pixel.tester.event.matching.expand.more" defaultMessage="View More" />,
    collapseMessage = <FormattedMessage id="pixel.tester.event.matching.expand.less" defaultMessage="View Less" />,
    children,
}) => {
    return (
        <>
            <Collapsible collapsed={collapsed} withAnimation>
                {children}
            </Collapsible>
            <div className={styles['expandable-view-text']} onClick={() => setCollapsed(!collapsed)}>
                {collapsed ? expandMessage : collapseMessage}
                {showArrow &&
                    (collapsed ? (
                        <KeyboardArrowDownIcon className={styles['arrow-icon']} fontSize="small" />
                    ) : (
                        <KeyboardArrowUpIcon className={styles['arrow-icon']} fontSize="small" />
                    ))}
            </div>
        </>
    );
};
